import { addItem } from "Redux/Slices/BreadCrumb";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import styles from "./Breadcrumb.module.scss";
import { useEffect } from "react";
import { _routes } from "SuperAdmin/Routes/routes";
const BreadcrumbAdmin = () => {
  const pathname = useLocation().pathname;
  const dispatch = useDispatch();
  const breadcrumb = useSelector((state) => state.breadcrumb.items);
  useEffect(() => {
    _routes.map((item) => {
      if (pathname.includes(item.path)) {
        dispatch(
          addItem({
            key: item.path,
            label: item.name,
            to: item.path,
            name: item.name,
            level: item.level,
          })
        );
      }
    });
  }, [pathname]);
  return (
    <div className={styles["bread-crumb"]}>
      {breadcrumb.map((item, index) => {
        if (index < breadcrumb.length - 1) {
          return (
            <div
              key={index}
              className={styles["breadcrumb-inner-item"]}
              onClick={() => {
                dispatch(addItem(item));
              }}
            >
              <div className={styles["breadcrumb-item"]}>
                <Link to={`/super-admin${item.to}`}>{item.name}</Link>
              </div>
              <span>/</span>
            </div>
          );
        } else {
          return (
            <div className={styles["breadcrumb-last-item"]} key={index}>
              <Link to={`/super-admin${item.to}`}>{item.name}</Link>
            </div>
          );
        }
      })}
    </div>
  );
};

export default BreadcrumbAdmin;
